"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiOutlinedInput = void 0;
var palette_1 = require("../../../theme/global/palette");
var typography_1 = require("../../../theme/global/typography");
var shape_1 = require("../../../theme/global/shape");
exports.MuiOutlinedInput = {
    root: __assign(__assign({ maxHeight: 48, borderRadius: shape_1.shape.borderRadius }, typography_1.typography.body1), { '&:hover $notchedOutline': {
            borderColor: palette_1.palette.common.black,
            '@media (hover: none)': {
                '&:hover $notchedOutline': {
                    borderColor: palette_1.palette.common.black,
                },
            },
        }, '&$focused $notchedOutline': {
            borderColor: palette_1.palette.primary.main,
            borderWidth: 2,
        }, '&$error $notchedOutline': {
            borderColor: palette_1.palette.error.main,
            borderWidth: 2,
        }, '&$disabled $notchedOutline': {
            borderColor: palette_1.palette.grey[400],
        }, '& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
            //remove arrows from number inputs
            display: 'none',
        } }),
    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
        paddingLeft: 14,
    },
    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
        paddingRight: 14,
    },
    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
        maxHeight: 'none',
        padding: "18.4px 14px",
        '&$marginDense': {
            paddingTop: 10.4,
            paddingBottom: 10.4,
        },
        '& .MuiInputAdornment-positionEnd': {
            alignSelf: 'end',
            marginTop: 6,
        },
    },
    /* Styles applied to the `NotchedOutline` element. */
    notchedOutline: {
        borderColor: palette_1.palette.grey[600],
        borderRadius: shape_1.shape.borderRadius,
        '& legend': {
            letterSpacing: 0.4,
        },
    },
    /* Styles applied to the `input` element. */
    input: {
        padding: "14.4px 14px",
        '&:-webkit-autofill': {
            borderRadius: 'inherit',
        },
    },
    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
        fontSize: typography_1.typography.pxToRem(14),
    },
    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
        padding: 0,
    },
    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
        paddingLeft: 0,
    },
    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
        paddingRight: 0,
    },
};
